import {
  FaBell,
  FaBook,
  FaCreditCard,
  FaHandshake,
  FaRegCreditCard,
  FaUsers,
} from "react-icons/fa";
import { GiGong, GiPodium, GiPodiumWinner } from "react-icons/gi";
import { TbRelationOneToManyFilled } from "react-icons/tb";
import { RiLockPasswordFill } from "react-icons/ri";
import { MdAddAPhoto, MdOutlineMessage } from "react-icons/md";
import { IoMdHelpCircle } from "react-icons/io";

export const HOME_NAV_LINKS = [
  {
    id: "accueil",
    label: "Accueil",
  },
  {
    id: "description",
    label: "Présentation",
  },
  {
    id: "tarifs",
    label: "Tarifs",
  },
  {
    id: "contact",
    label: "Contact",
  },
];

export const APP_LINK_ICONS = {
  "Resultats Public": GiPodium,
  Arbitrage: GiGong,
  "Arbitrage Jujitsu Combat": GiGong,
  "Arbitrage Jujitsu Duo": GiGong,
  Competition: GiPodiumWinner,
  "Competition Démo": GiPodiumWinner,
  "Listing Utilisateurs": FaUsers,
  "Listing Compétitions": GiPodium,
  "Listing Achats": FaCreditCard,
  Notifications: FaBell,
  "Formulaire Contact": MdOutlineMessage,
  "Règlement CS": FaBook,
  "Tableau de Score": TbRelationOneToManyFilled,
  "Formules Tarifs": FaRegCreditCard,
  Aide: IoMdHelpCircle,
  Accréditations: RiLockPasswordFill,
  Photos: MdAddAPhoto,
  Partenaires: FaHandshake,
  Messages: MdOutlineMessage,
};

export const APP_SECTIONS = {
  guest: {
    key: "guest",
    label: "Visiteurs",
    eyebrow: "Accès publics",
    description: "Résultats, arbitrage, règlement et outils visibles sans compte.",
    links: [
      "Resultats Public",
      "Arbitrage",
      "Arbitrage Jujitsu Combat",
      "Arbitrage Jujitsu Duo",
      "Règlement CS",
      "Tableau de Score",
      "Formules Tarifs",
      "Aide",
    ],
  },

  demonstration: {
    key: "demonstration",
    label: "Démonstration",
    eyebrow: "Mode découverte",
    description: "Accès limité pour tester l’espace compétition.",
    links: ["Competition"],
  },

  client: {
    key: "client",
    label: "Clients",
    eyebrow: "Gestion tournoi",
    description: "Compétitions, accréditations, photos, partenaires et messages.",
    links: ["Competition", "Accréditations", "Photos", "Partenaires", "Messages"],
  },

  admin: {
    key: "admin",
    label: "Administrateur",
    eyebrow: "Administration",
    description: "Gestion globale de la plateforme, utilisateurs et échanges.",
    links: [
      "Listing Utilisateurs",
      "Listing Compétitions",
      "Listing Achats",
      "Notifications",
      "Formulaire Contact",
    ],
  },
};

export const getSectionsForRole = (roleId) => {
  const role = Number(roleId || 0);

  if (role === 1) {
    return [APP_SECTIONS.guest, APP_SECTIONS.client, APP_SECTIONS.admin];
  }

  if (role === 3 || role === 4) {
    return [APP_SECTIONS.guest, APP_SECTIONS.client];
  }

  if (role === 2) {
    return [APP_SECTIONS.guest, APP_SECTIONS.demonstration];
  }

  return [APP_SECTIONS.guest];
};